import { render, staticRenderFns } from "./IconCard.vue?vue&type=template&id=6659d956&"
import script from "./IconCard.vue?vue&type=script&lang=js&"
export * from "./IconCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6659d956')) {
      api.createRecord('6659d956', component.options)
    } else {
      api.reload('6659d956', component.options)
    }
    module.hot.accept("./IconCard.vue?vue&type=template&id=6659d956&", function () {
      api.rerender('6659d956', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconCard.vue"
export default component.exports